import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Home from './components/Home';
import AboutUs from './components/AboutUS';
import TeamOfDoctors from './components/TeamOfDoctors';
import EquipmentRent from './components/EquipmentRent';
import Contact from './components/Contact';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { initializeAnalytics, trackPageView } from './analytics';

const TrackPageView = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname); 
  }, [location]);

  return null; 
};

function App() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    initializeAnalytics(); 
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Router>
      <TrackPageView />
      <div>
        <header className="bg-white shadow-lg p-4">
          <div className="container mx-auto flex justify-between items-center">
            <div className="flex items-center">
              <img src="logo.png" alt="Guardians Home Care Logo" className="h-8 w-8 mr-2 Logo" />
              <div className="text-2xl font-bold text-teal-600">
                <Link to="/">Guardians Home Care</Link>
              </div>
            </div>
            <button
              className="md:hidden text-gray-900 focus:outline-none"
              onClick={toggleMenu}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d={isOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16m-7 6h7'}
                />
              </svg>
            </button>
            <nav className="hidden md:flex space-x-6 text-lg">
              <Link to="/" className="hover:text-teal-600">Home</Link>
              <Link to="/about" className="hover:text-teal-600">About Us</Link>
              <Link to="/teamofdoctors" className="hover:text-teal-600">Team of Doctors</Link>
              <Link to="/equipmentrent" className="hover:text-teal-600">Medical Equipment</Link>
              <Link to="/contact" className="hover:text-teal-600">Contact Us</Link>
              <a href="https://wa.me/+919910967118" className="text-green-500 whatsapp-icon" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faWhatsapp} />
              </a>
            </nav>
          </div>

          {isOpen && (
            <nav className="md:hidden mt-4 space-y-4">
              <Link to="/" className="block text-gray-900 hover:text-teal-600">Home</Link>
              <Link to="/about" className="block text-gray-900 hover:text-teal-600">About Us</Link>
              <Link to="/teamofdoctors" className="block text-gray-900 hover:text-teal-600">Team of Doctors</Link>
              <Link to="/equipmentrent" className="block text-gray-900 hover:text-teal-600">Medical Equipment</Link>
              <Link to="/contact" className="block text-gray-900 hover:text-teal-600">Contact Us</Link>
              <a href="https://wa.me/+919910967118" className="button-331" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faWhatsapp} className="mr-2" /> Book Now
              </a>
            </nav>
          )}
        </header>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/teamofdoctors" element={<TeamOfDoctors />} />
          <Route path="/equipmentrent" element={<EquipmentRent />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>

        
      </div>
    </Router>
  );
}

export default App;
